import { useMutation } from '@tanstack/react-query';

import { botTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';

export const removeAllowedUser = ({ _id }: botTypes.RemoveAllowedUserData): Promise<void> => {
  return axios.delete(`/bot/allowed-users/${_id}`);
};

type UseRemoveAllowedUserOptions = {
  config?: MutationConfig<typeof removeAllowedUser>;
};

export function useRemoveAllowedUser({ config = {} }: UseRemoveAllowedUserOptions = {}) {
  return useMutation({
    onSuccess: () => {
      queryClient.invalidateQueries(['bot-allowed-users']);
    },
    ...config,
    mutationFn: removeAllowedUser,
  });
}
